import {
  __,
  el,
  TextControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editTitle = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(TextControl,
    {
      label: __('Titre'),
      className: "input-box",
      value: attributes.title,
      onChange: (value) => {
        setAttributes({ title: value });
      },
      onFocus: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.add('input-focused');
        }
      },
      onBlur: (e) => {
        const thisElement = e.target;
        const label = thisElement.parentNode.querySelector('label');
        if (label) {
          label.classList.remove('input-focused');
        }
      }
    }
  )
}

export { editTitle }
